import axios from 'axios'
import { checkSentry } from '@/script'
import * as Sentry from '@sentry/vue'
import createAxios from '@/api/axios_create'
import { config } from '@/script/cache/configuration'


export const _feedbackAPI = createAxios({
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Authorization': 'token ' + import.meta.env.VITE_APP_PAYED_API_TOKEN
    }
})

const $axiosCustomization = () => {
    const axiosPromise = (span) => createAxios({
        baseURL: `${config.url}local/webapi/ajax.php?action=getsettings`,
        headers: {
            'Content-Type': 'application/json'
        }
    })({ method: 'GET' }).then(resp => {
        if (span) {
            span.setAttribute('http.response.status_code', resp.status)
            span.setAttribute(
                'http.response_content_length',
                Number(resp.headers.get('content-length'))
            )
        }

        return Promise.resolve(resp)
    })
        .catch(resp => {
            if (span) {
                span.setAttribute('http.response.status_code', resp.code)
            }

            return Promise.reject(resp)
        })

    if (checkSentry()) {
        let url = `${config.url}local/webapi/ajax.php?action=getsettings`
        return Sentry.startSpan(
            { op: 'http.client', name: `GET ${url}` },
            (span) => {
                const parsedURL = new URL(url, location.origin)

                span.setAttribute('http.request.method', 'GET')
                span.setAttribute('server.address', parsedURL.hostname)
                span.setAttribute('server.port', parsedURL.port || undefined)

                return axiosPromise(span)
            }
        )
    } else {
        return axiosPromise(null)
    }
}
    export { $axiosCustomization }